var _defs, _path, _path2, _polyline, _path3, _path4, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st0, .st1 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .st1 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,7.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.5,8.1c.8-3.3,3.9-5.8,7.4-5.8s6.6,2.5,7.4,5.8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "7 6.6 2.3 8.1 .8 3.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,12.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.4,11.9c-.8,3.3-3.9,5.8-7.4,5.8s-6.6-2.5-7.4-5.8"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "12.8 13.4 17.5 11.9 19 16.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCircle);
export default __webpack_public_path__ + "static/media/switch_circle.d99a8a9c3ae30f2aea6a3fa5e42445bc.svg";
export { ForwardRef as ReactComponent };